import * as yup from "yup";

export function getCardStatementFormValidationSchema({
  filesValidationSchema,
  dependencies,
  cardFormat,
}) {
  if (cardFormat === "corporate")
    return yup.object().shape({
      file: filesValidationSchema.test(
        "required",
        "File is required",
        (file) => file && file.length
      ),
      card_type: yup
        .string()
        .oneOf(dependencies?.credit_card_types || [], "Card type is required"),
      company_code: yup
        .string()
        .length(4, "Must be 4 characters long")
        .required(),
    });
  else
    return yup.object().shape({
      file: filesValidationSchema.test(
        "required",
        "File is required",
        (file) => file && file.length
      ),
      date_start: yup.date().typeError("Please enter a valid date"),
      date_end: yup
        .date()
        .typeError("Please enter a valid date")
        .test(
          "is-valid-range",
          "End Date can't start before Start Date.",
          (endDate, context) => {
            const startDate = context.parent?.date_start;
            return (
              startDate < endDate ||
              (startDate?.getDate() === endDate?.getDate() &&
                startDate?.getMonth() === endDate?.getMonth() &&
                startDate?.getFullYear() === endDate?.getFullYear())
            );
          }
        ),
      card_type: yup
        .string()
        .oneOf(dependencies?.credit_card_types || [], "Card type is required"),
      company_code: yup
        .string()
        .length(4, "Must be 4 characters long")
        .required(),
      additional_info: yup.string().max(10, "Too long").optional(),
    });
}
